import { HttpInterceptorFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { tap, catchError } from 'rxjs';
import { throwError } from 'rxjs';

export const validationInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        if (body?.error?.validationErrors) {
          translateValidationErrors(body.error.validationErrors);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      // ABP validation hatalarını yakala
      if (error.status === 400 && error.error?.error?.validationErrors) {
        translateValidationErrors(error.error.error.validationErrors);
      }
      
      // ABP'nin direkt validation mesajlarını yakala
      if (error.error?.error?.message) {
        error.error.error.message = translateValidationMessage(error.error.error.message);
      }
      
      // ABP'nin error_description alanındaki validation mesajlarını yakala
      if (error.error?.error_description) {
        error.error.error_description = translateValidationMessage(error.error.error_description);
      }
      
      return throwError(() => error);
    })
  );
};

function translateValidationMessage(message: string): string {
  if (!message) return message;
  
  // MinLength validation
  if (message.includes('ThisFieldMustBeAStringOrArrayTypeWithAMinimumLengthOf') || 
      message.includes('field must be a string or array type with a minimum length of')) {
    const match = message.match(/\{?(\d+)\}?/);
    if (match) {
      return `Bu alan en az ${match[1]} karakter olmalıdır.`;
    }
  }
  
  // MaxLength validation
  if (message.includes('ThisFieldMustBeAStringOrArrayTypeWithAMaximumLengthOf') ||
      message.includes('field must be a string or array type with a maximum length of')) {
    const match = message.match(/\{?(\d+)\}?/);
    if (match) {
      return `Bu alan en fazla ${match[1]} karakter olabilir.`;
    }
  }
  
  // Required field
  if (message.includes('ThisFieldIsRequired') || 
      message.includes('field is required')) {
    return 'Bu alan zorunludur.';
  }
  
  // Email validation
  if (message.includes('ThisFieldIsNotAValidEmailAddress') ||
      message.includes('is not a valid e-mail address')) {
    return 'Geçerli bir e-posta adresi girin.';
  }
  
  // Phone validation
  if (message.includes('ThisFieldIsNotAValidPhoneNumber') ||
      message.includes('is not a valid phone number')) {
    return 'Geçerli bir telefon numarası girin.';
  }
  
  // Number range validation
  if (message.includes('ThisFieldMustBeBetween')) {
    const match = message.match(/\{?(\d+)\}?.*\{?(\d+)\}?/);
    if (match) {
      return `Bu alan ${match[1]} ile ${match[2]} arasında olmalıdır.`;
    }
  }
  
  // General invalid field
  if (message.includes('ThisFieldIsNotValid') ||
      message.includes('field is not valid')) {
    return 'Bu alan geçerli değil.';
  }
  
  // ABP localization key format (handles both :: and : separators)
  if (message.includes('AbpValidation::') || message.includes('AbpValidation:')) {
    const keyMatch = message.match(/AbpValidation::?([A-Za-z]+)(?:\{(\d+)\})?(?:\{(\d+)\})?/);
    if (keyMatch) {
      const key = keyMatch[1];
      const param1 = keyMatch[2];
      const param2 = keyMatch[3];

      switch(key) {
        case 'ThisFieldMustBeAStringOrArrayTypeWithAMinimumLengthOf':
        case 'TheFieldMustBeAStringOrArrayTypeWithAMinimumLengthOf':
          return param1 ? `Bu alan en az ${param1} karakter olmalıdır.` : 'Bu alan minimum karakter sayısını karşılamalıdır.';
        case 'ThisFieldMustBeAStringOrArrayTypeWithAMaximumLengthOf':
        case 'TheFieldMustBeAStringOrArrayTypeWithAMaximumLengthOf':
          return param1 ? `Bu alan en fazla ${param1} karakter olabilir.` : 'Bu alan maksimum karakter sayısını aşmamalıdır.';
        case 'ThisFieldMustBeAStringWithAMinimumLengthOfAndAMaximumLengthOf':
        case 'TheFieldMustBeAStringWithAMinimumLengthOfAndAMaximumLengthOf':
          return (param1 && param2) ? `Bu alan en az ${param1} ve en fazla ${param2} karakter olmalıdır.` : 'Bu alan karakter limitlerine uymalıdır.';
        case 'ThisFieldIsRequired':
        case 'TheFieldIsRequired':
          return 'Bu alan zorunludur.';
        case 'ThisFieldIsNotAValidEmailAddress':
        case 'TheFieldIsNotAValidEmailAddress':
          return 'Geçerli bir e-posta adresi girin.';
        case 'ThisFieldIsNotAValidPhoneNumber':
        case 'TheFieldIsNotAValidPhoneNumber':
          return 'Geçerli bir telefon numarası girin.';
        case 'ThisFieldMustBeBetween':
        case 'TheFieldMustBeBetween':
          return (param1 && param2) ? `Bu alan ${param1} ile ${param2} arasında olmalıdır.` : 'Bu alan belirtilen aralıkta olmalıdır.';
        case 'ThisFieldIsNotValid':
        case 'TheFieldIsNotValid':
          return 'Bu alan geçerli değil.';
        default:
          return 'Bu alan geçersiz.';
      }
    }
  }

  return message;
}

function translateValidationErrors(validationErrors: any) {
  if (!validationErrors) return;
  
  if (Array.isArray(validationErrors)) {
    validationErrors.forEach(error => {
      if (error.message) {
        error.message = translateValidationMessage(error.message);
      }
    });
  } else if (typeof validationErrors === 'object') {
    Object.keys(validationErrors).forEach(key => {
      if (Array.isArray(validationErrors[key])) {
        validationErrors[key] = validationErrors[key].map((msg: string) => 
          translateValidationMessage(msg)
        );
      }
    });
  }
}